import { render } from "./LmsAcademyContent.vue?vue&type=template&id=fee8eb40"
import script from "./LmsAcademyContent.vue?vue&type=script&lang=js"
export * from "./LmsAcademyContent.vue?vue&type=script&lang=js"

import "./LmsAcademyContent.vue?vue&type=style&index=0&id=fee8eb40&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__